import MonacoEditor, { useMonaco } from '@monaco-editor/react';

import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { action } from '../../lib/actionHelpers.js';

const stableObject = {};

const BoundMonacoEditor = ({ formId, id, placeholder, language, value, onChange }) => {
  const reduxValue = useSelector((state) => ((state.ui.boundForms[formId] || stableObject).state || stableObject)[id]);

  const monaco = useMonaco();

  useEffect(() => {
    if (monaco) {
      monaco.editor.defineTheme('myTheme', {
        base: 'vs',
        inherit: true,
        rules: [{ background: 'EDF9FA' }],
        colors: {
          'editor.lineHighlightBackground': '#fafafa',
          'editor.lineHighlightBorder': '#00000000',
        },
      });
    }
  }, [monaco]);

  const setValid = (valid) => {
    action(!valid ? 'uiSetFormInvalidField' : 'uiRemoveFormInvalidField', {
      formId,
      fieldId: id,
    });
  };

  const handleChange = (value) => {
    if (formId && id) {
      action('uiPatchFormState', {
        formId: formId,
        state: { [id]: value },
      });
    }
    if (typeof onChange === 'function') {
      onChange(value);
    }
    setValid(true);
  };

  return (
    <div className={'monaco-wrapper'}>
      <div className={'label'}>{placeholder}</div>
      <MonacoEditor
        defaultLanguage={language || 'html'}
        value={reduxValue || ''}
        theme="myTheme"
        options={{
          readOnly: false,
          minimap: { enabled: false },
          lineNumbers: 'off',
          overviewRulerLanes: 0,
          hideCursorInOverviewRuler: true,
          scrollbar: {
            vertical: 'hidden',
          },
          overviewRulerBorder: false,
          glyphMargin: false,
          folding: false,
          lineDecorationsWidth: 10,
          lineNumbersMinChars: 0,
        }}
        renderLineHighlight={'none'}
        // defineTheme={{
        // 	colors: {
        // 		'editor.lineHighlightBackground': '#00000000',
        // 		'editor.lineHighlightBorder': '#00000000'
        // 	}
        // }}
        onChange={handleChange}
      />
    </div>
  );
};

export default BoundMonacoEditor;
